import React from 'react';
import { Box, TextField } from '@mui/material';
import SelectEmpresa from '../../../form/SelectEmpresa';

export default function CabecalhoTab({ dados, empresas, alterar, bloqueado, editando }) {
    const campo = (name, label, type = 'text') => (
        <TextField key={name} name={name} label={label} type={type} value={dados[name] || ''} onChange={alterar}
            disabled={bloqueado} fullWidth size="small" required={name === 'descricao'}
            InputLabelProps={{ shrink: true }} inputProps={type === 'datetime-local' ? { step: 1 } : type === 'text' ? { maxLength: 255 } : {}} />
    );
    return <Box sx={{ display: 'grid', gap: 2, py: 2 }}>
        <fieldset disabled={bloqueado || editando} style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>
            <SelectEmpresa text="Empresa" name="empresaId" options={empresas} handleOnChange={alterar} value={dados.empresaId || ''} required notOptNull />
        </fieldset>
        {campo('descricao', 'Descrição')}
        <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' } }}>
            {campo('dataEleicao', 'Data da eleição', 'date')}
            {campo('inicioInscricao', 'Início das inscrições', 'datetime-local')}
            {campo('fimInscricao', 'Fim das inscrições', 'datetime-local')}
            {campo('localEleicao', 'Local da votação')}
            {campo('horaInicioEleicao', 'Início da votação', 'time')}
            {campo('horaFimEleicao', 'Fim da votação', 'time')}
            {campo('descricaoMandato', 'Descrição do mandato')}
            {campo('inicioMandato', 'Início do mandato', 'date')}
            {campo('fimMandato', 'Fim do mandato', 'date')}
        </Box>
        {['diretrizes', 'observacao'].map((name) => <TextField key={name} name={name} label={name === 'diretrizes' ? 'Diretrizes' : 'Observação'}
            value={dados[name] || ''} onChange={alterar} disabled={bloqueado} fullWidth multiline minRows={3} />)}
    </Box>;
}
